import React from "react";
import { Locale } from "@linkfluence/models/locale";
import Text from "@ui-kit/form/text";
import { tr } from "@radarly/i18n";
import Line from "./line";

export interface IProps {
  title: string;
  setTitle: (title: string) => void;
  locale?: Locale;
}

const PanelsCardEditionSidebarTitle = ({ title, setTitle, locale }: IProps) => (
  <Line title={tr(locale, "CUSTOM_PAGES::EDITOR::CARD_TITLE")}>
    <Text
      value={title}
      onChange={setTitle}
      variant="primary"
      placeholder={tr(locale, "CUSTOM_PAGES::EDITOR::CARD_TITLE_PLACEHOLDER")}
    />
  </Line>
);

export default PanelsCardEditionSidebarTitle;
